{
  "version": 1,
  "asset_id": "4b327af5-a006-4c3d-92dc-3bf6d316e7ba",
  "project_id": "01579873-aba5-45c2-b48e-0fe42afbbb35",
  "url": "/__l5e/assets-v1/4b327af5-a006-4c3d-92dc-3bf6d316e7ba/primary.png",
  "r2_key": "a/v1/01579873-aba5-45c2-b48e-0fe42afbbb35/4b327af5-a006-4c3d-92dc-3bf6d316e7ba/primary.png",
  "original_filename": "primary.png",
  "size": 355063,
  "content_type": "image/png",
  "created_at": "2026-06-16T18:44:27Z"
}
